<template>
  <div
    class="container-fluid infinite-list"
    infinite-scroll-immediate="false"
    infinite-scroll-disabled="disabled"
    v-infinite-scroll="getAppointReviewList"
  >
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="card search-card">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <div class="form-row">
            <!-- 申請日期 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <ValidationProvider
                  :rules="{ dateRangeRequired: true }"
                  v-slot="{ errors }"
                >
                  <label for="">申請日期</label>
                  <date-picker
                    class="w-100"
                    type="date"
                    range
                    :disabled-date="disabledAfterToday"
                    placeholder="YYYY-MM-DD~YYYY-MM-DD"
                    v-model="applyDateRange"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <!-- 職務名稱 -->
            <div class="col-sm-12 col-md-2">
              <div class="form-group">
                <label for="">{{ i18n("Position.PositionName") }}</label>
                <v-select
                  :options="positionList"
                  label="PositionName"
                  placeholder="請選擇"
                  :reduce="(positionName) => positionName.PositionName"
                  v-model="searchCondition.positionName"
                >
                </v-select>
              </div>
            </div>

            <!-- 應聘者名字 -->
            <div class="col-sm-12 col-md-2">
              <div class="form-group">
                <label for="">應聘者名字</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="請輸入關鍵字"
                  v-model="searchCondition.name"
                />
              </div>
            </div>
            <!-- 應聘者Email -->
            <div class="col-sm-12 col-md-2">
              <div class="form-group">
                <label for="">應聘者 Email</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="請輸入關鍵字"
                  v-model="searchCondition.email"
                />
              </div>
            </div>

            <div class="col-sm-12 col-md-1">
              <button
                type="button"
                class="btn btn-primary"
                style="margin-top: 30px"
                @click="
                  (currentPage = 1),
                    (personList = []),
                    (totalPerson = 0),
                    handleSubmit(getAppointReviewList)
                "
              >
                {{ i18n("Buttons.Search") }}
              </button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="personList.length > 0">
      <div class="tool-list-about-card">
        <span
          @click="gridStyle = 'block'"
          :class="{ active: gridStyle == 'block' }"
        >
          <eva-icon fill="#000" name="grid-outline" />
        </span>
        <span
          @click="gridStyle = 'list'"
          :class="{ active: gridStyle == 'list' }"
        >
          <eva-icon fill="#000" name="list-outline" />
        </span>
      </div>
    </div>

    <!-- 卡片列表 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard ref="personCard" :showCheckbox="false" :person="person">
          <template v-slot:tag="{ props }">
            <div class="result">{{ props.Status }}</div>
          </template>

          <template v-slot:middleContent="{ props }">
            <table>
              <tr>
                <th>應徵職務</th>
                <td>{{ props.PositionName }}</td>
              </tr>
            </table>
          </template>

          <template v-slot:buttonGroup="{ props }">
            <button type="button" @click="showDetailModal(props)">
              {{ i18n("Buttons.ShowData") }}
            </button>
            <button
              v-if="props.Status === '待簽核'"
              type="button"
              @click="viewAppointment(props)"
            >
              審核任用單
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 檢視資訊 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF"></eva-icon>
                履歷
              </span>
            </a>
            <a @click.prevent="detailCurrentPage = 1">
              <span>
                <eva-icon name="message-circle-outline" fill="#FFF"></eva-icon>
                面談紀錄
              </span>
            </a>
            <a
              v-if="showAppointmentRecord"
              @click.prevent="detailCurrentPage = 2"
            >
              <span>
                <eva-icon name="clipboard-outline" fill="#FFF"></eva-icon>
                任用單
              </span>
            </a>
            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              ></eva-icon>
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 1" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">面談紀錄</div>
                    <div class="item"></div>
                  </div>
                  <InterviewRecord :MatchId="MatchId"></InterviewRecord>
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 2" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">任用單</div>
                    <div class="item"></div>
                  </div>
                  <AppointmentRecord :MatchId="MatchId"></AppointmentRecord>
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
// 公司LOGO
import Logo from "@/components/company/Logo.vue";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 面談紀錄
import InterviewRecord from "@/components/back/CandidateData/InterviewRecord";
// 任用單
import AppointmentRecord from "@/components/back/CandidateData/AppointmentRecord";

export default {
  name: "AppointmentFormReview",

  components: {
    Logo,
    PersonCard,
    IdlResume,
    DlResume,
    InterviewRecord,
    AppointmentRecord,
  },
  data() {
    return {
      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // 人員卡片列表
      personList: [],

      // 分頁
      totalPerson: 0, // 總數
      currentPage: 1, // 當前頁數

      // 查詢條件
      applyDateRange: null,
      positionList: [], // 職務列表
      searchCondition: {},

      // 各資訊總覽
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeType: null, // 履歷種類
      showAppointmentRecord: false, // 是否顯示任用單
    };
  },

  methods: {
    // 取得任用審核列表 API
    getAppointReviewList() {
      const vm = this;
      const api = `${window.endpoints.api}/AppointmentModule/ApproveList/paging`;

      if (vm.totalPerson > 0) {
        if (vm.totalPerson > 30) {
          if (vm.totalPerson === vm.personList.length) {
            vm.stopGetNextPage = true;
            return;
          } else {
            vm.currentPage++;
            vm.stopGetNextPage = false;
          }
        } else {
          vm.stopGetNextPage = true;
          return;
        }
      }

      const params = {
        ...vm.searchCondition,
        approverUserId: vm.$cookies.get("userId"),
        applyTimeStart:
          vm.applyDateRange[0] === null
            ? null
            : moment(vm.applyDateRange[0]).format("YYYY-MM-DD"),
        applyTimeEnd:
          vm.applyDateRange[1] === null
            ? null
            : moment(vm.applyDateRange[1]).format("YYYY-MM-DD"),
        Page: vm.currentPage,
        PerPage: 30,
      };

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.Quantity > 0) {
              vm.totalPerson = response.data.Quantity;
              let newArr = response.data.Datas;

              let oldArr;
              if (vm.currentPage === 1) {
                oldArr = [];
              } else {
                oldArr = vm.personList;
              }
              vm.personList = oldArr.concat(newArr);
            }

            vm.$store.dispatch("updateLoading", false);
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 檢視資訊 Modal
    showDetailModal(item) {
      this.MatchId = item.MatchId;
      this.ResumeId = item.ResumeId;
      this.ResumeType = item.ResumeType;
      this.showAppointmentRecord = item.Status !== "待簽核";
      this.isShowDetail = true;
    },

    // 檢視任用單 button
    viewAppointment(item) {
      localStorage.setItem("candidate", JSON.stringify(item));
      this.$router.push({
        path: `/manager/form/evaluationreview`,
      });
    },

    // 日期不得大於今日
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    disabled() {
      return this.stopGetNextPage;
    },

    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },
  },

  created() {
    this.applyDateRange = [
      new Date(this.$common.getLastMonth()),
      new Date(this.$common.getToday()),
    ];

    this.$set(this.searchCondition, "status", "待簽核");

    this.getAppointReviewList();

    // 取得職務列表
    this.get_position(null)
      .then((result) => {
        this.positionList = result;
      })
      .catch((error) =>
        this.$notify({
          title: "職務列表取得失敗",
          message: error.response.data,
          type: "error",
          duration: 3500,
        })
      );
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
